import { Component, EventEmitter, Output } from '@angular/core';
import { CompassBuyComponent } from '../../../dashboard/company/compass-buy/compass-buy.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-compass-plan',
  standalone: true,
  imports: [CompassBuyComponent],
  templateUrl: './compass-plan.component.html',
  styleUrl: './compass-plan.component.scss'
})
export class CompassPlanComponent {

  link_output_string: string = '';
  @Output() link_output: EventEmitter<string> = new EventEmitter<string>();

  constructor(private router: Router) {}
  

  setLinkOutput(event: any) {
    this.link_output_string = event;
    this.link_output.emit(this.link_output_string);
    console.log('Link output from plan:', this.link_output_string);
    
    // we pass the value to the parent component
    this.router.navigate(['compass/buy/register'], { state: { link: this.link_output_string } });
  }

}
